var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTextMedium = function SvgTextMedium(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-20": 17,
    "data-width-24": 21,
    viewBox: "0 0 20.6 9.6",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M19.8.8H.8M19.8 4.8H.8M8.8 8.8h-8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTextMedium);
export default ForwardRef;